import React from 'react';
import '../styles/Footer.css';
import "../bbkandy/js/plugins/goodlayers-core/plugins/fontawesome/font-awesome.css"

const Footer = () => {
    return (
        <footer className="custom-footer">
        <div style={{padding : "20px"}}>
            <div className="hotale-footer-container hotale-container clearfix">
                <div className="hotale-footer-column hotale-item-pdlr hotale-column-15">
                    <div className="footer-logo widget widget_block widget_media_image hotale-widget">
                        <a href="/BananaBunksKandy" style={{ color: '#3a4a26' }}>
                            <img src="/bbkandy/images/logo/logo_g.png" alt="Banana Bunks Logo" width="110" height="27" />
                        </a>
                    </div>
                    <div className="footer-social-icons widget widget_block hotale-widget">
                        <a href="https://web.facebook.com/bananabunks" target="_blank" rel="noreferrer" style={{ color: '#3a4a26' }}>
                            <i className="fa fa-facebook"></i>
                        </a>
                        <a href="https://www.instagram.com/bananabunkskandy" target="_blank" rel="noreferrer" style={{ color: '#3a4a26' }}>
                            <i className="fab fa-instagram"></i>
                        </a>
                        <a href="https://wa.me/94767008800" target="_blank" rel="noreferrer" style={{ color: '#3a4a26' }}>
                            <i className="fab fa-whatsapp"></i>
                        </a>
                    </div>
                </div>

                <div className="hotale-footer-column hotale-item-pdlr hotale-column-15">
                    <div className="widget hotale-widget">
                        <h4 className="hotale-widget-title">Navigation</h4>
                        <ul style={{ listStyle: 'none', padding: 0 }}>
                            <li><a href="/BananaBunksKandy" style={{ color: '#3a4a26' }}>Home</a></li>
                            <li><a href="https://oryzalesure.uw.r.appspot.com/BananaBunksKandy/room" style={{ color: '#3a4a26' }}>Rooms & Bunks</a></li>
                            <li><a href="https://oryzalesure.uw.r.appspot.com/BananaBunksKandy/dining" style={{ color: '#3a4a26' }}>Eat & Drink</a></li>
                            <li><a href="https://oryzalesure.uw.r.appspot.com/BananaBunksKandy/gallery"style={{ color: '#3a4a26' }}>Gallery</a></li>
                            <li><a href="https://oryzalesure.uw.r.appspot.com/BananaBunksKandy/offers"style={{ color: '#3a4a26' }}>Offers</a></li>
                            <li><a href="https://oryzalesure.uw.r.appspot.com/BananaBunksKandy/aboutus"style={{ color: '#3a4a26' }}>About Us</a></li>
                            <li><a href="https://oryzalesure.uw.r.appspot.com/BananaBunksKandy/contactus"style={{ color: '#3a4a26' }}>Contact Us</a></li>
                        </ul>
                    </div>
                </div>

                <div className="hotale-footer-column hotale-item-pdlr hotale-column-15">
                    <div className="widget hotale-widget">
                        <h4 className="hotale-widget-title">Contact</h4>
                        <p><span>T :</span> <a href="tel:+94767008800" style={{ color: '#3a4a26' }}>+94 76 700 8800</a></p>
                        <p><span>E :</span> <a href="mailto:reservations@oryzaleisure.com" style={{ color: '#3a4a26' }}>reservations@oryzaleisure.com</a></p>
                    </div>
                </div>

                <div className="hotale-footer-column hotale-item-pdlr hotale-column-15">
                    <div className="widget hotale-widget">
                        <h4 className="hotale-widget-title">Hotel Address</h4>
                        <p>
                            139/1, Aniwatte Circular Road,<br />
                            Aniwatte, Kandy, Sri Lanka
                        </p>
                    </div>
                </div>
            </div>
        </div>
            <div className="hotale-copyright-wrapper">
                <div className="hotale-copyright-container">
                    <div className="hotale-copyright-left">
                        © 2024 Oryza Leisure. All Rights Reserved.Designed and Developed by Ollcode
                    </div>
                    <div className="hotale-copyright-right">
                        <a href="/Privacy">Privacy Policy</a>
                        <a href="/terms">Terms & Conditions</a>
                    </div>
                </div>
            </div>

        </footer>
    );
};

export default Footer;
